import { Component } from '@hatiolab/things-scene'

import ControlBase, { DIRECTION, INOUT, NODE, PIPELINE } from './base/control-base'

const IMAGE = new URL('../icons/request-reply.png', import.meta.url).href

const NATURE = {
  mutable: false,
  resizable: false,
  rotatable: false,
  properties: [],
  help: '/eipatterns/request-reply/request-reply'
}

export default class RequestReply extends ControlBase {
  static IMAGE: HTMLImageElement

  static get nature() {
    return NATURE
  }

  get nodes(): NODE[] {
    return [
      {
        name: 'In',
        description: 'Message inlet',
        inout: INOUT.IN,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.WEST,
        multiplicity: 1
      },
      {
        name: 'Out',
        description: 'Message outlet',
        inout: INOUT.OUT,
        type: PIPELINE.MESSAGE,
        direction: DIRECTION.EAST
      }
    ]
  }

  getImageElement(): HTMLImageElement {
    if (!RequestReply.IMAGE) {
      RequestReply.IMAGE = new Image()
      RequestReply.IMAGE.src = IMAGE
    }

    return RequestReply.IMAGE
  }
}

Component.register('request-reply', RequestReply)
